<template lang="html">
  <div>
    <template>
      <div>
        <div class="vx-card nexteventheader_div">
          <div class="vx-card__header">
            <div class="vx-card__title">
              <p class="">Manage Notifications</p>
            </div>
            <vs-button style="float:right;  " @click="$router.push({ path: '/admin/dashboard' })">Back</vs-button>
          </div>
        </div>
      </div>
      <vx-card code-toggler>
        <vs-tabs>
           <vs-tab label="SMS and Email Configuration" icon-pack="feather" icon="icon-box">
            <div class="tab-text">
              <br>
              <div class="show-notification">
                  <table style="width:100%" class="border-collapse">
                      <tr>
                          <th class="p-2 border border-solid d-theme-border-grey-light">Activation Data</th>
                          <th class="p-2 border border-solid d-theme-border-grey-light">SMS</th>
                          <th class="p-2 border border-solid d-theme-border-grey-light">EMAIL</th>
                          <th class="p-2 border border-solid d-theme-border-grey-light">Action</th>
                      </tr>
                      <tr v-for="(settings,index) in settingsData" :key="index">
                          <template>
                              <td class="p-2 border border-solid d-theme-border-grey-light">{{settings.title}}</td>
                              <td class="p-2 border border-solid d-theme-border-grey-light">
                                  <vs-switch v-model="settings.sms_notification" @input="changeSettings(settings.id,settings.slug,$event,'sms')">
                                      <span slot="on">On</span>
                                      <span slot="off">Off</span>
                                  </vs-switch>
                              </td>
                              <td class="p-2 border border-solid d-theme-border-grey-light">
                                  <vs-switch v-model="settings.email_notification" @input="changeSettings(settings.id,settings.slug,$event,'email')">
                                      <span slot="on">On</span>
                                      <span slot="off">Off</span>
                                  </vs-switch>
                              </td>
                              <td class="p-2 border border-solid d-theme-border-grey-light">
                                  <router-link
                                      class="mb-2 mr-1"
                                      type="filled"
                                      color="primary"
                                      :to="edittemplate_url+event_id+'/'+settings.slug+'/manage'"
                                      >
                                      <vs-button class="run_btn" color="success" type="filled">Edit Template</vs-button>
                                  </router-link>
                              </td>
                          </template>
                      </tr>
                  </table>
              </div>
            </div>
          </vs-tab>
          <vs-tab label="Custom Notifications" icon-pack="feather" icon="icon-box">
            <div class="tab-text">
              <div class="vx-row">
                <div class="vx-col w-full mt-5 customNotificationBlock">
                    <label>Select Notification Type:</label>
                    <vs-select v-model="typeSelected"
                    style="width: 60% !important;"
                    class="select-large"
                    @change="onTypeSelected()">
                      <vs-select-item
                        v-for="(item, index) in notificationTypes" :key="index"
                        :value="item.id"
                        :text="item.name"
                        class="w-full"
                      />
                    </vs-select>
                    <div class="smsedittemplate" style="margin-top: 10px;display: none;">
                      <form @submit.prevent="sendNotification('sms')" data-vv-scope="sms">
                        <label>SMS Body:</label>
                        <vs-textarea v-model="sms.smsBody" rows="10" name="sms.smsBody" v-validate="'required'" />
                        <span class="text-danger">{{ errors.first('sms.smsBody') }}</span>
                        <br>
                        <button
                        type="submit"
                        class="vs-component vs-button vs-button-primary vs-button-filled" style="margin-top:10px;float:right;">Next</button>
                        </form>
                    </div>
                    <div class="emailedittemplate" style="margin-top: 20px;display: none;">
                      <form @submit.prevent="sendNotification('email')" data-vv-scope="email">
                      <div style="margin-top: 20px;">
                        <label>Email Subject:</label>
                        <vs-input v-model="email.emailSubject" name="email.emailSubject" class="w-full" v-validate="'required'" />
                        <span class="text-danger">{{ errors.first('email.emailSubject') }}</span>
                      </div>
                      <div style="margin-top: 20px;">
                          <label>Email Body:</label>
                          <ckeditor v-model="email.emailBody" name="email.emailBody" v-validate="'required'" ></ckeditor>
                          <span class="text-danger">{{ errors.first('email.emailBody') }}</span>
                      </div>
                        <button
                        type="submit"
                        class="vs-component vs-button vs-button-primary vs-button-filled" style="margin-top:20px;float:right;">Next</button>
                        </form>
                      </form>
                    </div>
                </div>
                <div class="vx-col w-full mt-5 selectUserBlock" style="display: none;">
                  <div>
                    <div v-if="tableData.length">
                      <vs-table
                        multiple
                        v-model="selected"
                        pagination
                        :max-items="100"
                        search
                        :data="tableData"
                      >
                      <template slot="header">
                        <h4>Select Users</h4>
                      </template>
                      <template slot="thead">
                        <vs-th :sort-key="heading" v-for="heading in header" :key="heading">{{ heading }}</vs-th>
                      </template>
                      <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                          <vs-td
                            :data="col"
                            v-for="(col, indexcol) in data[indextr]"
                            :key="indexcol + col"
                          >{{ col }}</vs-td>
                        </vs-tr>
                      </template>
                      </vs-table>
                    </div>
                  </div>
                  <vs-button @click="handleBack">Back</vs-button>
                  <vs-button @click="handleNotifications" style="float: right;">Confirm</vs-button>
                </div>
              </div>
            </div>
          </vs-tab>
        </vs-tabs>
      </vx-card>
    </template>
  </div>
</template>

<script>
import $ from "jquery";
import { Validator } from "vee-validate";
export default {
  data: () => ({
    event_id: '',
    typeSelected: '',
    notificationTypes: [
      {"id": 1, "name": "SMS"},
      {"id": 2, "name": "Email"}
    ],
    smsBody: '',
    emailSubject: '',
    emailBody: '',
    sms: {
        smsBody: ""
      },
    email: {
        emailSubject: "",
        emailBody: ""
    },
    header: [],
    selected: [],
    tableData: [],
    data: [],
    percent_completed: 10,
    selected: [],
    event_id: "",
    tableData: [],
    header: [],
    sheetName: "",
    smsEmailConfig: [],
    is_enabled: true,
    configs:[],
    settingsData: [],
    edittemplate_url:"/admin/event/editnotification/",
    modifiedConfigs: []
  }),
  created() {
      this.event_id = this.$route.params.id;
      localStorage.setItem('settingsEventId', JSON.stringify(this.event_id));
  },
  mounted() {
    this.getEventUsers();
    this.getConfigData();
  },
  methods: {
    handleBack(){
      $(".customNotificationBlock").show();
      $(".selectUserBlock").hide();
      this.selected = this.tableData;
    },

    handleNotifications(){
      this.$vs.loading();
      let user_data = [];
      this.selected.forEach((sel, index)=>{
        user_data.push({"email" : sel.Email, "contact": sel.Contact});
      })
      this.data.user_data = user_data;
      this.$store
        .dispatch("CustomNotification", this.data)
        .then(response => {
            this.$vs.loading.close();
            this.$vs.notify({
                title: "Success",
                text: response.data.message,
                color: "success",
                position: "top-center"
            });
            location.reload();
        })
        .catch(error => {
            this.$vs.loading.close();
            this.$vs.notify({
                title: "Error",
                text: error,
                color: "danger",
                position: "top-center"
            });
        });
    },

    getEventUsers() {
      this.$vs.loading();
      this.$store
        .dispatch("GetEventUsers",this.event_id)
        .then(response => {
          this.$vs.loading.close();
          this.users = response.data.data
          this.header = ["First Name", "Last Name", "Email", "ID Number", "Contact"];
          this.users.forEach((user,index) => {
          this.tableData.push({"First Name": user.first_name, "Last Name": user.last_name, "Email": user.email, "ID Number": user.id_number, "Contact": user.mobile_number});
          });
          this.selected = this.tableData;
          // console.log(this.selected);
        })
        .catch(error => {
          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
            title: "Failed to load data",
            text: error,
            color: "danger",
            position: "top-center"
          });
          return false;
        });
    },

    onTypeSelected() {
        if(this.typeSelected == 1){
          $(".smsedittemplate").show();
          $(".emailedittemplate").hide();
          this.sms.smsBody = '';
          this.email.emailSubject = '';
          this.email.emailBody = '';
          this.errors.clear()
        } else {
          $(".smsedittemplate").hide();
          $(".emailedittemplate").show();
          this.sms.smsBody = '';
          this.email.emailSubject = '';
          this.email.emailBody = '';
          this.errors.clear()
        }
    },

    sendNotification(scope) {
      if (scope == "sms") this.submittedsms = true;
      if (scope == "email") this.submittedemail = true;
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          // this.$vs.loading();
          let sms_content = [];
          let email_content = [];
          if(this.typeSelected == 1){
            sms_content = [{"body": this.sms.smsBody}];
          } else {
            email_content = [
              {"subject": this.email.emailSubject, "body": this.email.emailBody},
            ]
          }

          this.data = {
            "event_id": this.event_id,
            "type": this.typeSelected,
            "sms_data": sms_content,
            "email_data": email_content
          }

          $(".customNotificationBlock").hide();
          $(".selectUserBlock").show();

        } else {
            this.$vs.notify({
              title: "Form submit failed",
              text: "Please enter required fields",
              color: "danger",
              position: "top-center"
            });
        }
      })
    },

    changeSettings(id,slug,event,type){
        localStorage.setItem('settingsData', JSON.stringify(this.settingsData));
        this.modifiedConfigs = [];
        this.settingsData.forEach((setting, index) => {
            this.modifiedConfigs.push({"slug": setting.slug, "is_sms_enabled": setting.sms_notification, "is_enabled": setting.email_notification})
        });
        let data = { "event_id": this.event_id, "configs": this.modifiedConfigs }
        this.$vs.loading();
        this.$store
        .dispatch("UpdateNotifications",data)
        .then(response => {
            this.$vs.loading.close();
            this.$vs.notify({
                title: "Success",
                text: "Cofiguration added successfully ",
                color: "success",
                position: "top-center"
            });
        })
        .catch(error => {
            this.$vs.loading.close();
            // Error response
            this.$vs.notify({
                title: "Failed to add Cofiguration",
                text: error,
                color: "danger",
                position: "top-center"
            });
            return false;
        });
    },

    getConfigData(){
        this.$vs.loading();
        this.$store
        .dispatch("GetSmsEmailConfig")
        .then(response => {
            if (localStorage.getItem('settingsData')) {
                this.settingsData = JSON.parse(localStorage.getItem('settingsData'));
            } else {
                this.smsEmailConfig = response.data.data;
                this.smsEmailConfig.forEach((config) => {
                    this.settingsData.push({"id":config.id, "title":config.title, "slug":config.slug, "sms_notification":true, "email_notification":true})
                })
            }

            this.$vs.loading.close();
        })
        .catch(error => {
            this.$vs.loading.close();
            // Error response
            this.$vs.notify({
                title: "Failed to load data",
                text: error,
                color: "danger",
                position: "top-center"
            });
            return false;
        });
    },

    handleAttendents() {
      $(".add-notification").hide();
      $(".show-notification").show();
    },
  },
}

</script>
<style lang="scss">
  .vx-card__actions{
    display: none;
  }
  .vx-card{
    box-shadow: 0px 25px 25px 0px rgba(0, 0, 0, 0.1) !important;
    border-radius: 0 !important;
  }
</style>
